import { SArray, lift } from 's-array';

import nonuniqueIndex from 'lib/nonuniqueIndex';

export interface IGrouping<K, T> {
    key : K,
    items : SArray<T>
}

export function groupBy<K extends string | number, T>(
    items : SArray<T>,
    keyFn : (item : T) => K
) : SArray<IGrouping<K, T>> {
    const itemsByKey = nonuniqueIndex(items, keyFn),
        keySet = items.map(keyFn)
            .reduce((found, next) => found.add(next), () => new Set<K>());

    return lift(() => Array.from(keySet()))
        .map(key => ({ key, items: itemsByKey(key) } as IGrouping<K, T>));
}


// WEBPACK FOOTER //
// ./lib/groupBy.ts